// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';


import SearchBarHeader from './SearchBarHeader';

import { isMobile } from '../../utils';

// INNER IMPORTS
import { VideoModal } from '../Modals/Video';
import { closeVideoModal, openVideoModal } from '../../Actions/main';
import { openParticipateModal } from '../../Actions/users';
import { LIVE_MUSIC, SERVICE, BAND, MUSICIAN } from "../../consts";
import { clientMedia } from '../../Config/Settings';

// svgs
// import lightnignsPurpleMugicsSVG from '../inlineSVGs/lightnignsPurpleMugicsSVG';
import FaPlay from 'react-icons/lib/fa/play';

import './Header.css';
import {AnalyticsService} from "../../Services";
import {browserHistory} from "react-router";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    renderCover() {
        // set the banner to user panel of main page
        if (this.props.location.pathname.includes('/user-panel')) return this.renderUserCover('user_panel_banner');

        // TODO:  add here the banner by type and by platform
        // EXAMPLE: main_banner_musician_web
        // NEW: banner_main_liveMusic_web
        if (isMobile()) {
            // let bannerImageType = 'main_banner_live_music';
            // let defaultMobileTitle = 'discover live shows near you';
            //
            // if (this.props.filters.type === 'service') {
            //     defaultMobileTitle = 'music services & business';
            //     bannerImageType = 'main_banner_service';
            // }
            // if (this.props.filters.type === 'band') {
            //     defaultMobileTitle = 'band maker - find bands';
            //     bannerImageType = 'main_banner_band';
            // }
            // if (this.props.filters.type === 'musician') {
            //     defaultMobileTitle = 'band maker - find member';
            //     bannerImageType = 'main_banner_musician';
            // }

            return null
        }
        return(
            <div
                className="mugics-slide"
                style={{backgroundImage: `url(${clientMedia()}/img/bannerImages/cover-figure-${this.props.filters.type}.png`}}
            >
            </div>
        )
    }

    renderUserCover(imgName) {
        // let bannerType = BANNER_MAIN;

        // if (!this.props.datatypes || !this.props.datatypes.banner[bannerType]) return (<div/>);
        // <div key={'carousel' + i} className="mugics-slide" style={{backgroundImage: 'url(' + b.imageUrl + ')'}}>

        let defaultMobileTitle = 'discover live shows near you';
        // let bannerImageType = 'main_banner_live_music';
        //
        // if (this.props.filters.type === 'service') {
        //     defaultMobileTitle = 'music services & business';
        //     bannerImageType = 'main_banner_service';
        // }
        // if (this.props.filters.type === 'band') {
        //     defaultMobileTitle = 'band maker - find bands';
        //     bannerImageType = 'main_banner_band';
        // }
        // if (this.props.filters.type === 'musician') {
        //     defaultMobileTitle = 'band maker - find member';
        //     bannerImageType = 'main_banner_musician';
        // }
        //
        // // set the banner to user panel of main page
        // if (this.props.location.pathname.includes('/user-panel')) {
        //     bannerImageType = 'user_panel_banner';
        //}

        if (!isMobile()) {
            return(
                <div
                    className="mugics-slide"
                    style={{backgroundImage: `url(${clientMedia()}/img/bannerImages/${imgName}.jpg`}}
                >
                </div>
            )
        }

        return(
            <div
                className="mugics-slide"
                style={{backgroundImage: `url(${clientMedia()}/img/bannerImages/${imgName}_mobile.jpg`}}
            >
                <div className={`mainTitle mobile ${this.props.filters.type}`}>{defaultMobileTitle}</div>
            </div>
        )

        // return this.props.datatypes.banner[bannerType].map((b, i) => {
        //     // TODO: change image for each cat type selected in filter
        //
        // })
    }

    onVidClick() {
        this.props.closeVideoModal();
        browserHistory.push('/#')
        this.props.openParticipateModal();
    }

    isUserPanel() {
        return this.props && this.props.location && this.props.location.pathname === '/user-panel'
    }

    handleWatchClick() {
        AnalyticsService.sendEvent(AnalyticsService.events.WATCH_VIDEO)
        this.props.openVideoModal();
    }

    renderMobile(selectedCat) {
        if (this.isUserPanel()) return null;

       // return <SearchBarHeader filters={this.props.filters} />

        return (
            <div className={`header mobile ${this.props.isMobileFilterBar ? '' : 'closed'}`} id="header">
                <div className={`type-line ${selectedCat}`}></div>

                <div className="carousel-wrapper">
                    {this.renderCover()}
                </div>
                <SearchBarHeader isHidden={!this.props.isMobileFilterBar} filters={this.props.filters} />
            </div>
        )
    }

    renderWebMain(selectedCatType, title, subTitle) {
        const video = this.props.datatypes.banner.video[selectedCatType];

        return (
            <div className={`header rtl`} id="header">
                {video ?
                    <div className="play-btn-wrapper" onClick={() => this.handleWatchClick()}>
                        <div className={`play ${selectedCatType}`}>
                            <i><FaPlay /></i>
                        </div>
                        <span>צפו בוידאו</span>
                    </div>
                : null }
                <div className="cover-wrapper">
                    <div className="header-search-wrapper">
                        <div className="header-text-wrapper">
                            {/*<SVGInline className="lightings-icon" svg={lightnignsPurpleMugicsSVG} component="i"/>*/}
                            <div className="text-wrapper">
                                <h2 className={`main-text ${selectedCatType}`}>{title}</h2>
                                <h5 className={`sub-text ${selectedCatType}`}>{subTitle}</h5>
                            </div>
                        </div>
                        <SearchBarHeader filters={this.props.filters} />
                    </div>

                    <div className="carousel-wrapper figure-cover-wrapper">
                        {this.renderCover()}
                    </div>

                </div>

                <VideoModal
                    isModalOpen={this.props.isVideoModalOpen}
                    closeModal={this.props.closeVideoModal}
                    vidUrl={(this.props.datatypes.banner.video[selectedCatType])}
                    onClick={() => this.onVidClick()}
                />
            </div>
        )
    }

    renderWebUserPanel() {
        let singleBanner = {};
        if (this.props.datatypes && this.props.datatypes.banner && this.props.datatypes.banner.userPanel) {
            singleBanner = this.props.datatypes.banner.userPanel[0] || {};
        }

        return (
            <div className={`header user-panel`} id="header">
                <div className="carousel-wrapper">
                    {this.renderCover()}
                </div>
                <div className="header-text-wrapper user-panel">
                    {/*<SVGInline className="lightings-icon" svg={lightnignsPurpleMugicsSVG} component="i"/>*/}
                    <div className="text-wrapper user-panel">
                        <h2 className={`main-text user-panel`}>{singleBanner.headerContent}</h2>
                        <h5 className={`sub-text user-panel`}>{singleBanner.subHeaderContent}</h5>
                    </div>
                </div>

                {this.props.datatypes.banner.video['userPanel'] ?
                    <VideoModal
                        isModalOpen={this.props.isVideoModalOpen}
                        closeModal={this.props.closeVideoModal}
                        vidUrl={this.props.datatypes.banner.video['userPanel']}
                        onClick={() => this.onVidClick()}
                    />
                : null}
            </div>
        )
    }

    renderWeb(selectedCatType) {
        if (this.props.location.pathname.includes('packages')) return null;

        // default is band finder
        let title;
        let subTitle;

        switch (selectedCatType) {
            case LIVE_MUSIC:
                title = <label>גלו הופעה אוטנטית מקומית <br/>ומרגשת סביבכם!</label> // 'DISCOVER LIVE MUSIC NEAR YOU';
                subTitle = `# מיוזיקס מחברת בין אומנים לקהל\n# מוזיקאים? פרסמו את ההופעה ב 30 שניות!` //'listen to the city with mugics';
                break;
            case SERVICE:
                title = <label>כל מי שקשור.ה לעולם המוזיקה<br/>נמצא.ת כאן!</label> //  'MUSIC SERVICES & BUSINESS';
                subTitle = `# מוזיקס פה כדי לחבר בין אמנים ולהפוך את החיים שלהם לקלים\n# פרסמו - מקומות להופיע חדרי חזרות, להקות להשכרה ועוד...` //'Discover service providers from the music industry, around you';
                break;
            case BAND:
                title = <label>השתמשו ביוצר הלהקות כדי<br/>לחבור ללהקה שמתיאמה לכם!</label> //  'BAND MAKER';
                subTitle = `# מוזיקס פה כדי לעזור ללהקות להתגבש בקלות` // 'So easy to group as a band';
                break;
            case MUSICIAN:
                title = <label>השתמשו ביוצר הלהקות כדי<br/>למצוא את המוזיקאי שחסר לכם</label> //  'BAND MAKER';
                subTitle = `# מוזיקס פה כדי לעזור ללהקות להתגבש בקלות` // 'So easy to group as a band';
                break;
            default:
                title = <label>גלו הופעה אוטנטית מקומית <br/>ומרגשת סביבכם!</label> // 'DISCOVER LIVE MUSIC NEAR YOU';
                subTitle = `# מיוזיקס מחברת בין אומנים לקהל\n# מוזיקאים? פרסמו את ההופעה ב 30 שניות!` //'listen to the city with mugics';
        }

        return this.isUserPanel() ? this.renderWebUserPanel() : this.renderWebMain(selectedCatType, title, subTitle);
    }

    render() {
        if (!this.props || !this.props.datatypes) return null;

        const selectedCatType = this.props.filters && this.props.filters.type;

        return isMobile() ? this.renderMobile(selectedCatType) : this.renderWeb(selectedCatType)
    }
}

Header.propTypes = {
    datatypes: PropTypes.object,
    location: PropTypes.object,
    closeVideoModal: PropTypes.func,
    openVideoModal: PropTypes.func,
    isVideoModalOpen: PropTypes.bool,
    openParticipateModal: PropTypes.func,
    filters: PropTypes.object,
    isMobileFilterBar: PropTypes.bool
};

const mapStateToProps = (state) => ({
    datatypes: state.main.datatypes,
    isVideoModalOpen: state.main.isVideoModalOpen,
    filters: state.main.filters,
    isMobileFilterBar: state.main.isMobileFilterBar
});

export default connect(mapStateToProps, { closeVideoModal, openVideoModal, openParticipateModal })(Header);



// WEBPACK FOOTER //
// ./src/Components/Main/Header.js